
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navbar />
      
      <main className="flex-grow container mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-sm">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Terms and Conditions</h1>
          
          <div className="prose prose-blue max-w-none">
            <p className="text-gray-600 mb-4">
              By using CareerGuideKerala.in, you agree to the following terms:
            </p>
            
            <ul className="list-disc pl-6 mb-6 text-gray-600">
              <li className="mb-2">Services are provided on an "as is" basis.</li>
              <li className="mb-2">Results from career guidance are recommendations, not guarantees.</li>
              <li className="mb-2">Unauthorized use of our content is prohibited.</li>
              <li className="mb-2">We reserve the right to modify or discontinue services.</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Use of Services</h2>
            <p className="text-gray-600 mb-4">
              Our services are designed to provide career guidance based on the information you provide. 
              The accuracy of our recommendations depends on the accuracy and completeness of the information 
              you provide during assessments.
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Intellectual Property</h2>
            <p className="text-gray-600 mb-4">
              All content on CareerGuideKerala.in, including text, graphics, logos, images, and software, 
              is the property of CareerGuideKerala.in and is protected by copyright laws. Unauthorized use, 
              reproduction, or distribution of our content is strictly prohibited.
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Limitation of Liability</h2>
            <p className="text-gray-600 mb-4">
              CareerGuideKerala.in and its team shall not be liable for any direct, indirect, incidental, 
              special, or consequential damages resulting from the use or inability to use our services or 
              for the cost of procurement of substitute services.
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Changes to Terms</h2>
            <p className="text-gray-600 mb-4">
              We reserve the right to modify these terms at any time. Continued use of our services after 
              such modifications constitutes your acceptance of the revised terms.
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Contact Us</h2>
            <p className="text-gray-600 mb-4">
              If you have any questions about our terms and conditions, please contact us at{" "}
              <a href="mailto:careerguidekerala@gmail.com" className="text-brand-blue hover:underline">
                careerguidekerala@gmail.com
              </a>
              .
            </p>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default TermsAndConditions;
